export default __webpack_public_path__ + "static/media/poly-4.55c55e46.svg";